document.addEventListener("DOMContentLoaded", function () {
  // --------------------------------------------------------------------------------------------------------------------------------------- DOM ELEMENT REFERENCES
  const homeHeaderWrapper = document.querySelector('.customHeader'); //Header applied on homepage
  const globalHeaderWrapper = document.querySelector('.globalHeader'); //Header applied on whole website

    const isPeanutsLanding =
  Boolean(
    document.querySelector(
      '[data-peanuts-hero]'
    )
  );
  
  let lastScrollTop = 0;

  let isMenuCollapsed = false;

  const blueSrc = 'https://cdn.shopify.com/s/files/1/0800/7319/5840/files/marinella-logo-dark.svg?v=1699972221'; // Blue full logo
  const bluenameSrc = 'https://cdn.shopify.com/s/files/1/0800/7319/5840/files/Marinella_logo_name_blue.png?v=1750235538'; // Blue logo text only
    
 function getDeviceType() {
  const width = window.innerWidth;

  if (width <= 768) {
    return 'mobile';
  } else if (width >= 769 && width <= 1199) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}

  let deviceType = getDeviceType(); // Inizializza riconoscendo il device utilizzato per la navigazione (desktop, tablet o mobile)
  // Brakpoints sono: da 0px a 768px, da 769px a 1300px, da 1300px in su


  //***************************************************************
  //********** LOCK/UNLOCK BODY SCROLL ON MENU HOVER ***************

    const homeNav =
  document.querySelector(
    ".homeNav"
  );

const mainNav =
  document.querySelector(
    ".main-nav"
  );


/*
 * Durante il reveal PEANUTS non blocchiamo
 * il body quando si passa sul menu.
 *
 * La hero usa window.scrollY per calcolare
 * la propria animazione: bloccare il body
 * durante questa fase può farla tornare
 * verso progress = 0.
 *
 * Quando il reveal è terminato,
 * il menu torna al comportamento normale.
 */
const peanutsHeroIsActive = () => {

  return (
    isPeanutsLanding &&
    document.documentElement
      .classList
      .contains(
        'peanuts-hero-active'
      )
  );

};

const peanutsHeaderShouldStayTransparent = () => {

  return (
    isPeanutsLanding &&
    document.documentElement
      .classList
      .contains(
        'peanuts-header-transparent-lock'
      )
  );

};

if (homeNav) {

  let noScrollTimeout;


  homeNav.addEventListener(
    "mouseenter",
    () => {

      /*
       * PEANUTS:
       * nessun body lock durante il reveal.
       */
      if (
        peanutsHeroIsActive()
      ) {

        document.body
          .classList
          .remove(
            "no-scroll"
          );

        return;
      }


      noScrollTimeout =
        setTimeout(
          () => {

            document.body
              .classList
              .add(
                "no-scroll"
              );

          },
          1000
        );

    }
  );


  homeNav.addEventListener(
    "mouseleave",
    () => {

      clearTimeout(
        noScrollTimeout
      );


      document.body
        .classList
        .remove(
          "no-scroll"
        );

    }
  );


} else if (mainNav) {

  let noScrollTimeout;


  mainNav.addEventListener(
    "mouseenter",
    () => {

      if (
  peanutsHeroIsActive()
) {

  document.body
    .classList
    .remove(
      "no-scroll"
    );

  return;
}


      noScrollTimeout =
        setTimeout(
          () => {

            document.body
              .classList
              .add(
                "no-scroll"
              );

          },
          1000
        );

    }
  );


  mainNav.addEventListener(
    "mouseleave",
    () => {

      clearTimeout(
        noScrollTimeout
      );


      document.body
        .classList
        .remove(
          "no-scroll"
        );

    }
  );
      
}
  //************************************
  //********** LOGO CODE ***************

  if(homeHeaderWrapper){ //Check if user is on homepage and only then trigger the following code

    const announcementBarHomeWrapper = document.querySelector('.announcementHome'); //Announcement bar applied on homepage
    const announcementBarHome = announcementBarHomeWrapper?.querySelector('announcement-bar'); //Announcement bar applied on homepage
    const homeHeader =  homeHeaderWrapper?.querySelector('.header'); // Homepage header
    const menu = document.querySelector('.main-menu'); //Website menu section
    const homeLogoWrapper = document.querySelector('.home-logo-wrapper'); //Website logo in header on homepage
    const homeLogo = homeLogoWrapper?.querySelector('img'); //Website logo in header on homepage
    const homeBurger = document.querySelector('.main-menu__toggle'); //Burger menu icon in homepage
    let isMobileMenuOpen = 0;
  
    const originalSrc = homeLogo.src; // White full logo
    
    // -------------------------------------------------------------------------------------------- SET INITIAL LOGO STATE
    const scrollTop =
  window.scrollY ||
  document.documentElement.scrollTop;

if (
  scrollTop === 0 ||
  peanutsHeaderShouldStayTransparent()
) {

  homeLogo.src =
    originalSrc;

} else {

  homeLogo.src =
    blueSrc;

}

    // ----------------------------------------------------------------- SET HEADER AS "NOT SCROLLED" ON PAGE LOAD TO APPLY CORRECT STYLE ON PAGE LOAD
    homeHeader.classList.add('not-scrolled');

    
    //************************************
    //HOME HEADER HOVER EFFECTS TO CHANGE LOGO

    // ---------------------------------------------------------------------- ANNOUNCEMENT BAR, HEADER AND LOGO TRANSFORMATIONS ON HOME AND DESKTOP ONLY WHEN HOVER
    if (deviceType === 'desktop'){

      // ------------------------------------------------------------------------------------------ CHANGE BRAND LOGO TO BLUE ON HEADER HOVER (HOME AND DESKTOP ONLY)
      homeHeader.addEventListener('mouseenter', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
         if (
  deviceType === 'desktop' &&
  (
    scrollTop === 0 ||
    peanutsHeaderShouldStayTransparent()
  )
) {
  homeLogo.src = blueSrc;
}
      });
  
      // ----------------------------------------------------------------------- BACK TO WHITE BRAND LOGO ON MOUSE LEAVE FROM HEADER IF HEADER NOT SCROLLED (HOME AND DESKTOP ONLY)
      homeHeader.addEventListener('mouseleave', (event) => {
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop;

  const nextElement =
    event.relatedTarget;

  const goingIntoMegaMenu =
    nextElement instanceof Element &&
    (
      nextElement.closest('.gm-submenu') ||
      nextElement.closest('.em-v30a-shell') ||
      nextElement.closest('.homeNav')
    );

  /*
   * Se sto semplicemente passando
   * dall'header al mega menu aperto,
   * NON devo rimettere il logo bianco.
   */
  if (goingIntoMegaMenu) {
    return;
  }

  if (
  deviceType === 'desktop' &&
  (
    scrollTop === 0 ||
    peanutsHeaderShouldStayTransparent()
  )
) {
  homeLogo.src =
    originalSrc;
}
});
      
      const desktopMenuItems =
  document.querySelectorAll(
    '.homeNav > li.gm-level-0'
  );

desktopMenuItems.forEach(item => {

  item.addEventListener(
    'mouseenter',
    () => {
      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop;

      if (
  scrollTop === 0 ||
  peanutsHeaderShouldStayTransparent()
) {

  homeHeader.classList.add(
    'indirectHover'
  );

  announcementBarHome.classList.add(
    'indirectHover'
  );

  homeLogo.src =
    blueSrc;
}
    }
  );

  item.addEventListener(
    'mouseleave',
    (event) => {
      const scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop;

      const nextElement =
        event.relatedTarget;

      const goingIntoMegaMenu =
        nextElement instanceof Element &&
        (
          nextElement.closest('.em-v30a-shell') ||
          nextElement.closest('.gm-submenu')
        );

      if (goingIntoMegaMenu) {
        return;
      }

      if (
  scrollTop === 0 ||
  peanutsHeaderShouldStayTransparent()
) {

  homeHeader.classList.remove(
    'indirectHover'
  );

  announcementBarHome.classList.remove(
    'indirectHover'
  );

  homeLogo.src =
    originalSrc;
}
    }
  );

});

      homeHeaderWrapper.addEventListener('mouseenter', () => { // Change announcement bar background color to blue on header hover (HOME AND DESKTOP ONLY)
        announcementBarHome.classList.add('indirectHover');
      });


      homeHeaderWrapper.addEventListener('mouseleave', () => { // Turn header to white background and change logo to blue if hover on announcement bar  (HOME AND DESKTOP ONLY)
        announcementBarHome.classList.remove('indirectHover');
      });

      announcementBarHome.addEventListener('mouseenter', () => { // Back to transparent header and white logo on mouse leave from announcement bar only if page not scrolled (HOME AND DESKTOP ONLY)
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        homeHeader.classList.add('indirectHover');
        if (
  deviceType === 'desktop' &&
  (
    scrollTop === 0 ||
    peanutsHeaderShouldStayTransparent()
  )
) {

  homeLogo.src =
    blueSrc;

}
      });

      announcementBarHome.addEventListener('mouseleave', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        homeHeader.classList.remove('indirectHover');          
          if (
  deviceType === 'desktop' &&
  (
    scrollTop === 0 ||
    peanutsHeaderShouldStayTransparent()
  )
) {

  homeLogo.src =
    originalSrc;

}
      });
    }

    // ---------------------------------------------------------------------------------------- LOGO UPDATE ON SCREEN RESIZE
    window.addEventListener(
  'resize',
  () => {

    const scrollTop =
      window.scrollY ||
      document.documentElement.scrollTop;


    if (
      scrollTop === 0 ||
      peanutsHeaderShouldStayTransparent()
    ) {

      homeLogo.src =
        originalSrc;

    } else {

      homeLogo.src =
        blueSrc;

    }

  }
);

    //************************************
    //HOME HEADER SCROLL EVENT HANDLER

   
      window.addEventListener('scroll', () => {
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop;

  if (!deviceType) {
    return;
  }

 const peanutsTransparentLock =
  isPeanutsLanding &&
  peanutsHeaderShouldStayTransparent();


if (peanutsTransparentLock) {

  /*
   * Desktop:
   * teniamo aperto anche il menu orizzontale.
   */
  if (
    deviceType === 'desktop'
  ) {

    menu.classList.remove(
      'menu--collapse'
    );

    isMenuCollapsed = false;

  }


  /*
   * Tutti i device:
   * manteniamo lo stato transparent
   * originale E. Marinella.
   */
  announcementBarHome.classList.remove(
    'scrolled'
  );


  homeHeader.classList.remove(
    'scrolled'
  );

  homeHeader.classList.add(
    'not-scrolled'
  );


  homeLogo.classList.remove(
    'reduced'
  );

  /*
 * Quando rientriamo verso l'alto
 * nella zona transparent PEANUTS,
 * ripristiniamo esplicitamente
 * il logo corretto.
 *
 * Se stai interagendo con il menu:
 * logo blu.
 *
 * Altrimenti:
 * logo completo bianco.
 */
const peanutsMenuHovered =
  deviceType === 'desktop' &&
  (
    homeHeader.matches(
      ':hover'
    ) ||
    document
      .querySelector(
        '.homeNav'
      )
      ?.matches(
        ':hover'
      ) ||
    document
      .querySelector(
        '.em-v30a-shell'
      )
      ?.matches(
        ':hover'
      ) ||
    document
      .querySelector(
        '.gm-submenu'
      )
      ?.matches(
        ':hover'
      )
  );


const peanutsMobileMenuOpen =
  homeHeader.classList.contains(
    'mobileOpen'
  );


if (
  peanutsMenuHovered ||
  peanutsMobileMenuOpen
) {

  homeLogo.src =
    blueSrc;

} else {

  homeLogo.src =
    originalSrc;

}


  lastScrollTop =
    scrollTop <= 0
      ? 0
      : scrollTop;


  return;
}

  /* SCROLL VERSO IL BASSO */
  if (scrollTop > lastScrollTop) {

    /* Solo desktop: nasconde il menu orizzontale */
    if (
  deviceType === 'desktop'
) {

  menu.classList.add(
    'menu--collapse'
  );

  isMenuCollapsed = true;
}

    /*
     * MOBILE + TABLET + DESKTOP
     * Header bianco, icone blu,
     * logo ridotto/blu.
     */
    if (scrollTop > 0) {
      announcementBarHome.classList.add(
        'scrolled'
      );

      homeHeader.classList.remove(
        'not-scrolled'
      );

      homeHeader.classList.add(
        'scrolled'
      );

      homeLogo.classList.add(
        'reduced'
      );

      homeLogo.src =
        bluenameSrc;
    }
  }

  /* SCROLL VERSO L'ALTO */
  else if (scrollTop < lastScrollTop) {

    /* Desktop: riapre il menu orizzontale */
    if (
      deviceType === 'desktop' &&
      isMenuCollapsed
    ) {
      menu.classList.remove(
        'menu--collapse'
      );

      isMenuCollapsed = false;
    }
  }

  /* RITORNO IN CIMA */
  if (scrollTop === 0) {

    homeHeader.classList.remove(
      'scrolled'
    );

    homeHeader.classList.add(
      'not-scrolled'
    );

    announcementBarHome.classList.remove(
      'scrolled'
    );

    homeLogo.classList.remove(
      'reduced'
    );

    /*
     * Menu aperto:
     * header bianco + logo blu.
     *
     * Menu chiuso:
     * header trasparente + logo bianco.
     */
    const desktopMegaMenuOpen =
  deviceType === 'desktop' &&
  (
    document.querySelector('.homeNav')?.matches(':hover') ||
    document.querySelector('.em-v30a-shell')?.matches(':hover')
  );

if (
  homeHeader.classList.contains('mobileOpen') ||
  desktopMegaMenuOpen
) {
  homeLogo.src = blueSrc;
} else {
  homeLogo.src = originalSrc;
}

    if (deviceType === 'desktop') {
      menu.classList.remove(
        'menu--collapse'
      );

      isMenuCollapsed = false;
    }
  }

  lastScrollTop =
    scrollTop <= 0
      ? 0
      : scrollTop;
});
    
   

   /* FIX MARINELLA - MENU MOBILE STABILE */

const mainDisclosure =
  document.querySelector('.main-menu__disclosure');

function syncMobileHeader() {
  if (
    window.innerWidth > 768 ||
    !mainDisclosure
  ) return;
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop;

  const menuIsOpen =
    mainDisclosure.open &&
    !mainDisclosure.classList.contains('is-closing');

  homeHeader.classList.toggle('mobileOpen', menuIsOpen);

  if (announcementBarHome) {
    announcementBarHome.classList.toggle(
      'mobileOpen',
      menuIsOpen
    );
  }

  if (menuIsOpen) {
    homeLogo.src = blueSrc;
  } else if (
    scrollTop === 0 ||
    peanutsHeaderShouldStayTransparent()
  ) {
    homeLogo.src = originalSrc;
  } else {
    homeLogo.src = bluenameSrc;
  }
}

homeBurger.addEventListener('click', () => {
  requestAnimationFrame(syncMobileHeader);
});

if (mainDisclosure) {
  const menuObserver = new MutationObserver(() => {
    syncMobileHeader();
  });

  menuObserver.observe(mainDisclosure, {
    attributes: true,
    attributeFilter: ['open', 'class']
  });
}

  window.addEventListener('resize', () => {
    deviceType = getDeviceType(); // aggiorna il valore a ogni resize
  });
    
  } // -----------------------------------------------------------------------------------------------------------------------End of 'if(homeHeaderWrapper)'
 
}); // End of 'document.addEventListener("DOMContentLoaded")'